import { render, staticRenderFns } from "./ProductTree.vue?vue&type=template&id=2dfe642e&scoped=true&"
import script from "./ProductTree.vue?vue&type=script&lang=js&"
export * from "./ProductTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe642e",
  null
  
)

export default component.exports